import { render, staticRenderFns } from "./current-user-panel.vue?vue&type=template&id=8e16a1ee&scoped=true"
import script from "./current-user-panel.vue?vue&type=script&lang=js"
export * from "./current-user-panel.vue?vue&type=script&lang=js"
import style0 from "./current-user-panel.vue?vue&type=style&index=0&id=8e16a1ee&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e16a1ee",
  null
  
)

export default component.exports